import type { FaireReviewEntity } from "../../entity_types/review";

// Real per-product review for LE LIS's "GINGHAM DETAIL KNIT SWEATER
// CARDIGAN" (p_7eppbpgtqe), read from GET /api/product-reviews/product/
// p_7eppbpgtqe (the same data source that powers the product's own PDP
// review list) — verbatim comment, real reviewer, real rating, real publish
// date.
export const review_ll4: FaireReviewEntity = {
  token: "review_ll4",
  type: "review",
  brandName: "LE LIS",
  brandToken: "b_q8gu9by5sv",
  productToken: "p_7eppbpgtqe",
  reviewType: "product",
  reviewerName: "Savannah M.",
  reviewerLocation: "Dublin, TX",
  stars: 5,
  reviewText: "Quality was amazing!",
  reviewDate: "Aug 5, 2026",
  meta: {
    source: "api",
    importedAt: "2026-08-13T17:05:56.180Z",
    importedBy: "entity-db-cli",
  },
};
